<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 600px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'UpLevelDayStat',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        {
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(data) {
      this.initChart()
      const time = []
      const d = {}
      const legend = {
        count: '观看广告数',
        rate: '广告渗透率',
        spin_avg: '人均发放',
        spins: '发放体力',
        user: '观看人数',
        user_avg: '人均次数',
        arppu: '广告变现ARPPU',
        arpu: '广告ARPU',
        ad_price: '广告收入'
      }
      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(val.date))
        for (const k in val.data.total) {
          if (k === 'type') {
            continue
          }
          if (d[k] === undefined) {
            d[k] = []
          }
          d[k].push(val.data.total[k])
        }
      }

      for (const i in d) {
        const val = d[i]
        this.option.legend.data.push(legend[i])
        const temp = {
          name: legend[i],
          data: val,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          itemStyle: {
            // 设置柱子宽度
            barWidth: '50%'
          }
        }
        this.option.series.push(temp)
      }
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    },
    refresh2(data) {
      this.initChart()
      const time = []
      const upLevelData = {}
      for (let k = 2; k <= 10; k++) {
        upLevelData[k] = []
      }
      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(data[i].date))
        for (const k in val.data) {
          if (k == 1) {
            continue
          }
          const lv = val.data[k]
          upLevelData[lv.level].push(lv.rate)
        }
      }
      for (const i in upLevelData) {
        const val = upLevelData[i]
        this.option.legend.data.push(i)
        const temp = {
          name: i,
          data: val,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          itemStyle: {
            // 设置柱子宽度
            barWidth: '50%'
          }
        }

        if (i === 'rate') {
          temp.yAxisIndex = 1
        }

        this.option.series.push(temp)
      }
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
